module.exports = __webpack_public_path__ + "img/drop_up.81b27c44.svg";